import apiClient from "@/lib/api-client";
import { toast } from "@/lib/toast";
import { useActivityStore } from "@/stores/activity-store";

export type ClientTimedFeature = "trawl" | "snowball" | "add_angle_setup";
export type RunOutcome = "success" | "failed" | "cancelled";

/** Record how long a browser-driven job took, so its pill and Activity row
 * can say "usually X–Y" later. Fire-and-forget: a lost row costs nothing. */
export function postRunTiming(
  conceptId: string,
  feature: ClientTimedFeature,
  sizeN: number,
  startedAt: number,
  outcome: RunOutcome,
): void {
  const json = { feature, size_n: sizeN, duration_ms: Math.max(0, Date.now() - startedAt), outcome };
  // Never let telemetry throw into the job that just finished.
  void Promise.resolve()
    .then(() => apiClient.post(`api/concepts/${conceptId}/run-timing`, { json }))
    .catch(() => {});
}

/** "Trawl finished · 212 new papers" with a way into the Activity panel. */
export function toastJobFinished(conceptId: string, title: string, message: string, id?: string): void {
  toast.success(title, {
    id,
    description: message,
    action: { label: "Activity", onClick: () => useActivityStore.getState().openPanel(conceptId) },
  });
}
